exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body[data-v-44be1ab8]{padding:0 5rem 5rem}@media (max-width:1024px){.card-body[data-v-44be1ab8]{padding:1rem}}.card-body .card-text[data-v-44be1ab8]{margin-top:1rem;margin-bottom:1rem;font-size:1rem}.card-body ol li[data-v-44be1ab8]{font-size:1rem}", ""]);

// exports
